import { Link } from "react-router-dom";
import s from "../clinic.module.css";
import u from "../../ui/ui.module.css";
import {
  Button,
  Field,
  Input,
  Textarea,
  FormSection,
  FormGrid,
  FormGridSpan,
} from "../../ui";

export default function AdminDoctorDataForm({
  edit,
  setEdit,
  onSubmit,
  userId = null,
}) {
  return (
    <form onSubmit={onSubmit} className={s.patientDataForm}>
      <FormSection
        title="Профиль"
        description="Группы тренера настраиваются на вкладке «Группы»"
      >
        <FormGrid>
          <FormGridSpan>
            <Field label="ФИО">
              <Input
                required
                value={edit.full_name}
                onChange={(e) =>
                  setEdit({ ...edit, full_name: e.target.value })
                }
              />
            </Field>
          </FormGridSpan>
          <FormGridSpan>
            <Field label="Описание">
              <Textarea
                className={u.textareaCompact}
                rows={3}
                value={edit.description}
                onChange={(e) =>
                  setEdit({ ...edit, description: e.target.value })
                }
              />
            </Field>
          </FormGridSpan>
          <Field label="Email для входа">
            <Input
              type="email"
              value={edit.email}
              onChange={(e) => setEdit({ ...edit, email: e.target.value })}
            />
          </Field>
        </FormGrid>
      </FormSection>

      <div className={u.formActions}>
        <Button type="submit">Сохранить</Button>
        {userId ? (
          <Link
            className={`${u.btn} ${u.btnSecondary} ${u.btnMd}`}
            to={`/manage/app/team/members/${userId}`}
          >
            Доступ в Команде
          </Link>
        ) : null}
      </div>
    </form>
  );
}
